import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import clsx from "clsx";
import { AIMContextViewAtom } from "./AIMPanelContext";
import { useSetAtom } from "jotai";

export function PanelSkeleton({ title }: { title?: string }) {
    const setAIMContextView = useSetAtom(AIMContextViewAtom);

    return (
        <div
            className={clsx(
                "px-6 pb-6",
                "custom-scrollbar absolute inset-0 flex min-h-0 flex-col overflow-hidden",
            )}
        >
            <div className="sticky my-4 flex flex-col">
                <RightSidebarButton
                    onClick={() => {
                        setAIMContextView(null);
                    }}
                />
                {title && <h2 className="pageheading">{title}</h2>}
                <div
                    className={clsx(
                        "mt-3 h-24 w-full bg-slate-700",
                        "animate-pulse rounded",
                    )}
                />
            </div>
            <div className="mt-6 flex flex-col gap-4">
                {Array.from({ length: 5 }).map((_, index) => (
                    <div
                        key={index}
                        className={clsx(
                            "h-10 w-full bg-slate-700",
                            "animate-pulse rounded",
                        )}
                    />
                ))}
            </div>
        </div>
    );
}
